import React, { useMemo, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

import Loading from '../../components/Loader/Loading'
import ArtworkCard from '../../components/Collection/ArtworkCard'

import { useActiveWeb3React } from '../../hooks'
import { getArtworksV3 } from '../../service/nft'
import { AuctionBake } from '../../constants/artwork'
import { contractAddresses } from '../../sushi/lib/constants'

const Wapper = styled.div`
  margin-top: -70px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const DropsWrapper = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  position: relative;
  padding: 0px 25px 0 25px;
  text-align: center;
`
const Banner = styled.div<{bg: string}>`
  width: 100%;
  min-height: 220px;
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
  `}
`
const Mask = styled.div`
  padding: 72px 10px 40px 10px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-bottom: 20px;
  `}
`
const Title = styled.div`
  font-size: 24px;
  font-family: 'Roboto-Bold';
  color: ${({ theme }) => theme.white};
  max-width: 700px;
  margin: 0 auto;
`
const Tips = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.white};
  font-family: 'Roboto-Regular';
  margin: 0 auto;
  margin-top: 15px;
  max-width: 700px;
`
// const Title2 = styled(Title)`
//   font-size: 40px;
//   color: ${({ theme }) => theme.text6};
// `
// const Tips2 = styled(Tips)`
//   color: ${({ theme }) => theme.text6};
// `
const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 459px);
  margin-top: 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    grid-template-columns: repeat(auto-fill, 350px);
  `}
`

const defaultList: [] = []
export default function Drops () {
  const { account, chainId } = useActiveWeb3React()
  const [artworkList, setArtworkList] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]

  const params = useMemo(() => {
    const ids = [
      '111-5931', '111-6103'
    ]
    return {
      nftType: -1,
      onSale: -3,
      offset: 0,
      limit: 100,
      ids: ids.join(','),
    }
  }, [])

  const fetchList = useCallback(async () => {
    setLoading(true)
    getArtworksV3(chainId as number, {
      ...params
    }, (err: any, data: any) => {
      setLoading(false)
      if (err) return
      if (data.code !== 0) return
      const list: any[] = data.data.list || []
      const artworks = list.map((d: any) => {
        let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
            || (d.price && Number(d.price))
            || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) &&  d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
        return {
          ...d,
          tokenId: d.nftId || d.id,
          nftLevel: level,
          status: d.status !== undefined ? d.status : 1,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      setArtworkList(artworks.length > 0 ? artworks : defaultList)

    })
  }, [params, chainId, account])

  // Init List
  useEffect(() => {
    fetchList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, chainId])

  return (
    <>
      <Loading open={loading} />
      <Wapper>
        <Banner bg={'/images/drops/banner/banner_abduction-collection1.png'}>
          <Mask>
            <Title>
              The abduction & the collection
            </Title>
            <Tips>
            There is a love for storytelling, with the scope to evoke emotions to the viewer, this is what art does. This is what these two scenes hope to do. Always fascinated from the ’80s, this is a homage to the mystery sci-fi film genre with an 80’s touch. Two animation videos, as realistic as possible which were created with a lot of love, trying to recreate that nostalgic and electric atmosphere.
            </Tips>
            <Tips>
            Influenced from sci-fi retro mystery movies. Two different scenes correspond to, two different fractions of the same story. Let’s just set up the two scenes. The first scene, the abduction: It’s an ordinary summer night in a small medieval village in Tuscany, Italy. Suddenly, some spaceships invaded the area, by appearing in the sky and abducting, in a few secs, our mini bakery van which was returning home after a busy day at work, after selling doughnuts all around the neighborhood and made a lot of people smile. Then, the second scene follows: The collection. This scene takes place on another deserted planet, where we can find the secret base of aliens and practically the place where they store their collectibles. This is where those horrible creatures place our minivan which they took in the first scene. Thankfully, Our mini drone spy, can infiltrate their area and take a quick look at their headquarters, now we can set up a plan and take it back.
            </Tips>
          </Mask>
        </Banner>
        <DropsWrapper>
          {/* <Title2>Custom Horror</Title2> */}
          {/* <Tips2>Play a fully on-chain board-game with collectible NFTs that are backed by real value! Alchemy Toys are the “gold-standard” NFTs , upheld by the growing game treasury...</Tips2> */}
          {
            artworkList.length ?
              <ArtworkList>
                {
                  artworkList.map((d) => {
                    return (
                      <ArtworkCard key={d.id} artwork={d} width={427} height={427} padding={'16px'}></ArtworkCard>
                    )
                  })
                }
              </ArtworkList>
            : null
          }
        </DropsWrapper>
      </Wapper>
    </>
  )
}